import './angular-css/style.css';
import './index.css';

require('./vendors');
require('./store');
require('./app');
require('./angular/app/login');
require('./angular/app/documents');
require('./angular/app/portal');
require('./angular/app/logout');
require('./angular/app/workflow');
require('./angular/app/projects');
require('./angular/app/reports');
require('./angular/app/search');
require('./angular/app/saved-search');
require('./angular/common/grid');
require('./angular/common/columns');
require('./angular/common/auth');
require('./angular/common/alerts');
require('./angular/common/menu');
require('./angular/common/file');
require('./angular/common/util');
require('./angular/common/legacy');
require('./angular/common/dialog');
require('./angular/common/settings');
require('./angular/common/filters');
require('./angular/common/checkbox');
require('./angular/common/context-menu');
require('./angular/common/dragdrop');
require('./angular/common/profile');
require('./angular/common/properties');
require('./angular/common/section-panel');
require('./angular/common/preview');
require('./angular/common/multiselect');
require('./angular/common/path-select');
require('./angular/common/responsive');
require('./angular/common/tooltip');
require('./angular/common/upload');
require('./angular/common/header');
require('./angular/common/dropHandler');
require('./angular/common/project-editor');
require('./react-angular');

global.dlwebComponents = require('dlweb-components');